module.exports = __webpack_public_path__ + "img/area_1.12c9a554.png";